module.exports = __webpack_public_path__ + "e8a1f4968881da8be2af030925c01597.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/make-moves-together/cha-biker.png
// module id = 1749
// module chunks = 1